export const PAGE_TYPES = Object.freeze({
  PRIVATE: "private",
  PUBLIC: "public",
});

export const ALL_PAGE_TYPES = Object.values(PAGE_TYPES);
